import React from "react";
import { BLOCKS_STATES } from "../../../containers/Blocks/Blocks.constants";
import BlocksItem from "./BlocksItem/BlocksItem";
import { List, Alert } from "antd";

export default function BlocksList({ status, data, error }) {
  return (
    <>
      {status !== BLOCKS_STATES.failure ? (
        <List
          loading={
            status === BLOCKS_STATES.loading || status === BLOCKS_STATES.idle
          }
          dataSource={data}
          renderItem={(item) => <BlocksItem item={item} />}
        ></List>
      ) : (
        <Alert message={error.message} type="error" />
      )}
    </>
  );
}
